import ViewAll from '@components/shared/bytes/ViewAll';
import { IsMobile } from '@lib/isMobile';
import cn from 'classnames';

const BytesTitle = ({ title, highlight, titleOnly = false, description, href }) => {
  return (
    <div className="mb-10 flex w-11/12 items-end space-y-2 lg:w-auto">
      <div
        className={cn(
          { '!w-full': titleOnly },
          'flex w-9/12 flex-col items-start space-y-0 font-extrabold md:w-11/12'
        )}
      >
        <div className="flex gap-x-1 tracking-wide">
          <p className="select-none font-satoshi-bold text-[1.3rem] font-bold  line-clamp-2 lg:text-xl">
            {title}
            <span className="ml-1 w-fit  border-b-4 border-red lg:hidden">{highlight}</span>
          </p>
          <p className="hidden w-fit border-b-4 border-red font-satoshi-bold font-bold  md:ml-1 md:-mt-2 lg:inline-flex lg:h-[1.8rem] lg:text-xl">
            {highlight}
          </p>
        </div>
        <p className="!mt-1 hidden font-satoshi-medium  text-base font-light tracking-normal text-[#6C6C6C] lg:block">
          {description}
        </p>
      </div>
      {!titleOnly && <ViewAll className="!flex" href={href} />}
    </div>
  );
};

export default BytesTitle;
